import {
  Accordion,
  AccordionItem,
  Group,
  NumberFormatter,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { useMemo } from "react";
import { useReportingStore } from "../../../../stores/ReportingStore";
import EmailSummaryMulti from "./summary/SmsSummaryMulti";
import EmailSummary from "./summary/SmsSummary";
import ReportingInfo from "../ReportingInfo";
import { useLanguage } from "../../../../stores/LanguageStore";
import { IconMessage } from "@tabler/icons-react";

const ReportingSms = () => {
  const lang = useLanguage((s) => s.language);
  const actualStatsDate = useReportingStore((s) => s.actualStatsDate);
  const programmations = useReportingStore((s) => s.programmations);

  const statistics = useMemo(() => {
    const totals = actualStatsDate.reduce((acc, curr) => {
      Object.keys(curr).forEach((key) => {
        if (key !== "date") {
          acc[key] = (acc[key] || 0) + curr[key];
        }
      });
      return acc;
    }, {});
    return totals;
  }, [actualStatsDate]);

  const component = useMemo(() => {
    if (programmations.length > 1) {
      return <EmailSummaryMulti />;
    }
    return <EmailSummary />;
  }, [programmations.length]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group>
            <ThemeIcon
              variant="filled"
              radius={"md"}
              size={"lg"}
              color={"var(--mantine-color-green-7)"}
            >
              <IconMessage />
            </ThemeIcon>

            <Title order={3} fw={500}>
              {lang.reports.activity_sms}
            </Title>
            <ReportingInfo>
              <Text>{lang.reports.activity_sms_text}</Text>
            </ReportingInfo>

            <Text ml={"auto"} mr={32} size="lg">
              <NumberFormatter
                value={statistics.sms_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.sms_sent}
            </Text>
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={8}>
            {/* <SegmentedControl
              data={[
                {
                  label: lang.reports.sending_summary,
                  value: "summary",
                },
                {
                  label: lang.reports.performance,
                  value: "perf",
                },
              ]}
              value={active}
              onChange={setActive}
              size="lg"
            /> */}
            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingSms;
